/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Zurück',
    SCAN_QR_CODE: 'Scannen Sie den QR-Code'
  },
  ERRORS: {
    GET_DOCUMENT: 'Dokument kann nicht abgerufen werden.',
    INVALID_CODE: 'Ungültiger Code.',
    VALIDATING_CODE: 'Der Code kann nicht validiert werden.'
  },
  LABELS: {
    DELIVERY_ORDER: 'Lieferauftrag',
    ERROR: 'Fehler',
    OR: 'Oder',
    PACKAGE: 'Paket',
    TRACKING_OR_CODE: 'Tracking-Nummer oder Paketcode'
  }
};
